import React from 'react'
import { Link } from 'react-router-dom'
import heropic from '../images/pic.png'

const Hero = () => {
    return (
        <div>
            <div className="md:flex justify-between mt-16 max-sm:flex-row bg-gray-800  ">

                <div className="">
                    <div className="pl-20 pt-20">
                        <h2 className="text-6xl font-extrabold max-sm:text-4xl text-white  ">Unforgettable Branding <br/>Every Sip</h2>
                    </div>
                    
                    <Link to={'/advertise'}><button  className='bg-red-200 rounded-md text-2xl p-4 ml-20 my-6 '>Advertise with us</button></Link>
                </div>
                <div className="img w-3/5 max-sm:w-3/4 m-auto">
                    <img src={heropic} alt="Brand" className='w-3/5' />
                </div>
            </div>
        </div>
    )
}

export default Hero